import { useTranslation } from 'react-i18next'

import Button from '../../Button'

import ShareIcon from '../../../icons/share-2.svg'

function FilterBarShareTemplateButton({ isSkeleton, onShare }) {
  const { t } = useTranslation()

  return (
    <Button.Text
      isGreySecondary
      isHovered
      beforeIconProps={{ Icon: ShareIcon }}
      isSkeleton={isSkeleton}
      text={t('Table.ShareFilterBtnKey')}
      onClick={onShare}
    />
  )
}

export default FilterBarShareTemplateButton
